import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
} from '@angular/core';
import { TelXLCustomerDirectoryPanelComponent } from '@dxp/components';
import { TelXLButtonComponent } from '@dxp/elements';
import { ICustomerDirectoryEvent } from '@dxp/core/models';
import { EndCustomerStateService } from '../services/end-customer.state.service';

@Component({
    selector: 'end-customer-directory',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TelXLCustomerDirectoryPanelComponent, TelXLButtonComponent],
    templateUrl: './customer-directory.component.html',
    styleUrl: './customer-directory.component.scss',
})
export class EndCustomerDirectoryComponent {
    readonly #endCustomerStateService = inject(EndCustomerStateService);

    viewCustomer(event: ICustomerDirectoryEvent) {
        this.#endCustomerStateService.setSelectedEndCustomer(event.item);
        this.#endCustomerStateService.setView('details');
    }

    viewEndCustomer() {
        this.#endCustomerStateService.setSelectedEndCustomer(
            this.#endCustomerStateService.activeEndCustomer(),
        );
        this.#endCustomerStateService.setView('details');
    }

    businessUnitId = computed<string | null>(() =>
        this.#endCustomerStateService.bussinesUnit(),
    );

    customerId = computed<string | undefined>(
        () => this.#endCustomerStateService.activeEndCustomer()?.customerId,
    );
}
